/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Check, X } from 'lucide-react';
export const CellData = ({
    initiallyMapped,
    onToggle,
    product,
    colKey,
    index,
    absoluteIndex,
    columnId,
    mappingValueId,
    isYes,
    isNo,
    viewMode,
}) => {
    const [isMapped, setIsMapped] = useState(initiallyMapped);
    useEffect(() => {
        setIsMapped(initiallyMapped);
    }, [initiallyMapped]);

    const handleClick = () => {
        const nextState = !isMapped;
        if (onToggle) {
            const success = onToggle(nextState, product, colKey, index, absoluteIndex, columnId, mappingValueId);
            if (success !== false) {
                setIsMapped(nextState);
            }
        } else {
            setIsMapped(nextState);
        }
    };

    const isSemanticallyTrue = isMapped && !isNo;

    return (
        <div
            className={`flex items-center justify-center h-full w-full transition-all duration-200 ${viewMode ? '' : 'cursor-pointer'}`}
            {...(viewMode ? {} : { onClick: handleClick })}
        >
            <div className={`p-1.5 rounded-lg border flex items-center justify-center shadow-sm transition-colors ${isSemanticallyTrue
                ? 'border-[#D1E9CF] bg-green-100 text-[#4CAF50]'
                : 'border-[#E0E0E0] bg-red-100 text-[#FF5252]'
                }`}>
                {isSemanticallyTrue ? (
                    <Check size={14} strokeWidth={3} />
                ) : (
                    <X size={14} strokeWidth={3} />
                )}
            </div>
        </div>
    );
};